import React, { useEffect, useState } from 'react'
// import QrReader from 'react-qr-scanner'
import QrReader from 'react-qr-reader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faSync } from '@fortawesome/free-solid-svg-icons'
 
import './QrScanner.css'

export default function QrTest (props) {

    const [delay, setDelay] = useState(100)
    const [result, setResult] = useState('no result')
    const [cameraId, setCameraId] = useState(null)
    const [devices, setDevices] = useState([])
    const [facingMode, setFacingMode] = useState('user');
    const [scanning, setScanning]  = useState(false)
    const [regex, setRegex] = useState(null)
    const [statusClassName, setStatusClassName] = useState('')
    const [debug, setDebug] = useState([])

    useEffect(() =>{
    // console.log('loading')
    //     navigator.mediaDevices.enumerateDevices()
    //         .then((devices) => {
    //         const videoSelect = []
    //         devices.forEach((device) => {
    //             console.log(device)
    //             if (device.kind === 'videoinput') {
    //             videoSelect.push(device)
    //             }
    //         })
    //         return videoSelect
    //         })
    //         .then((devices) => {
    //             setCameraId(devices[0].deviceId)
    //             setDevices(devices)            
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    
        const re = new RegExp(props.pattern, '');
        setRegex(re)

    }, [])

    function addDebugMessage(message) {
      const d = new Date()      
      setDebug(prev => [`${d.getMilliseconds()}:${message}`, ...prev])
    }

    function handleScan(data){
        // setScanning(false)
        // console.log('data',data)
        addDebugMessage(data)
        if (scanning && data != null) {
            addDebugMessage(data)

            let match
            if ((match = regex.exec(data)) != null) {
              console.log('match')
                const payload = {
                  raw: data,
                  pattern: props.pattern,
                  match: match                  
                }                
                props.onSuccess(payload)
                
                // setResult(`Boleto: ${match[2]}`)
                setScanning(false)
                props.onStatusChange({ scanning: false })
                // setStatusClassName('status-success')
            } else {
              console.log('no match')
            }
        } else {
          // console.log('else', data)
        }
        
    }
    function handleError(err){
        console.error(err)
        addDebugMessage(err)
        setScanning(false)
    }

    function handleScanClick() {
      if (!scanning) {
        setResult('')
        setStatusClassName('')
        setScanning(true)
        props.onStatusChange({ scanning: true })
        setFacingMode('environment')
      } else {
        console.log('tons')        
        setScanning(false)
        props.onStatusChange({ scanning: false })        
      }
    }

    function render() {
        const previewStyle = {
                  height: props.size || 200,
                  width: props.size || 200,
                }
        return (
            <div className={`qrscanner ${statusClassName}`} style={{width: props.size || 200, height: props.size || 200}}>
              <div className="scanner-overlay" style={scanning ? { display:'none' } : {}}>
                <button onClick={handleScanClick} disabled={scanning}><FontAwesomeIcon icon={faQrcode} /> escanear</button>
              </div> 
                
          {/* {devices.length > 0 && <> Choose: <select
              onChange={e => {
                const value = e.target.value
                setCameraId(value)                
              }}
            >
              {devices.map((deviceInfo, index) => (
                <React.Fragment key={deviceInfo.deviceId}><option value={deviceInfo.deviceId}>{deviceInfo.label || `camera ${index}`}</option></React.Fragment>
              ))}
            </select> </>} */}
            <div className="scanner-preview" onClick={handleScanClick}>              
              <QrReader
                delay={delay}
                style={previewStyle}
                onError={handleError}
                onScan={handleScan}
                facingMode={facingMode}
                showViewFinder={false}

                // chooseDeviceId={cameraId}
              />
            </div>
            {/* <div className="scanner-debug">
              {debug.map(d => <div>{d}</div>)}
            </div> */}
        </div>
      )
    }

      return render()

}

// class QrTest extends Component {
//   constructor(props){
//     super(props)
//     this.state = {
//       delay: 100,
//       result: 'No result',
//     }
 
//     this.handleScan = this.handleScan.bind(this)
//   }
//   handleScan(data){
//     this.setState({
//       result: data,
//     })
//   }
//   handleError(err){
//     console.error(err)
//   }
//   render(){
//     const previewStyle = {
//       height: 240,
//       width: 320,
//     }
 
//     return( cameraId &&
//       <div>
//         <QrReader
//           delay={this.state.delay}
//           style={previewStyle}
//           onError={this.handleError}
//           onScan={this.handleScan}
//         //   facingMode="rear"
//             chooseDeviceId={cameraId}
//           />
//         <p>{this.state.result}</p>
//       </div>
//     )
//   }
// }

// export default QrTest